var _circle, _path, _path2, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBroseLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 250,
    r: 55,
    fill: "#3a3a3a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 220 L95 280 L115 280 L115 255 L125 255 C135 255 140 250 140 245 C140 240 135 235 125 235 L115 235 L115 220 L95 220 Z M115 240 L125 240 C130 240 132 242 132 245 C132 248 130 250 125 250 L115 250 L115 240 Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115 255 L125 255 C135 255 140 260 140 265 C140 270 135 275 125 275 L115 275 L115 255 Z M115 260 L125 260 C130 260 132 262 132 265 C132 268 130 270 125 270 L115 270 L115 260 Z",
    fill: "white"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 195,
    y: 245,
    fontFamily: "Arial, sans-serif",
    fontSize: 48,
    fontWeight: "bold",
    fill: "#3a3a3a"
  }, "BROSE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 275,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#3a3a3a",
    letterSpacing: "2px"
  }, "FILMS PRODUCTION")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroseLogo);
export default __webpack_public_path__ + "static/media/brose-logo.1e07a1efc0558102c75278ce6e9c53ac.svg";
export { ForwardRef as ReactComponent };